// Where the dashboard is running.
//
// The Bubble phone app opens the dashboard with ?app=bubble_mobile. Inside it,
// buttons that leave for smartfilterpro.com (add device, subscription,
// shipments, profile) are hidden: the app has its own screens for those.
//
// Read once at startup (src/index.tsx imports this first, before sign-in tidies
// the URL) and remembered for the rest of the tab's session, so reloads and
// in-app navigation keep it.

const PARAM = 'app';
const BUBBLE_MOBILE = 'bubble_mobile';
const STORAGE_KEY = 'sfp_in_bubble_app';

function detectBubbleApp(): boolean {
  const fromUrl = new URLSearchParams(window.location.search).get(PARAM) === BUBBLE_MOBILE;
  try {
    if (fromUrl) sessionStorage.setItem(STORAGE_KEY, '1');
    return fromUrl || sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return fromUrl; // storage blocked: the URL flag still works for this load
  }
}

/** True inside the Bubble phone app: hide links back to smartfilterpro.com. */
export const inBubbleApp: boolean = detectBubbleApp();

/**
 * Inside the phone app the dashboard should behave like an app screen, not a
 * web page: no pinch-zoom, no double-tap zoom, and no iOS zoom-in when a text
 * field is focused. The website keeps normal zoom (people rely on it).
 *
 *  - viewport `maximum-scale=1, user-scalable=no`: Android WebView and the
 *    app's iOS web view honour it (Safari itself ignores it, hence the rest).
 *  - `touch-action: pan-x pan-y`: scrolling only, no zoom gestures (Chrome,
 *    Android WebView, iOS 13+).
 *  - iOS `gesturestart` and two-finger moves are cancelled as a last resort.
 */
function lockZoom(): void {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
  }
  document.documentElement.style.touchAction = 'pan-x pan-y';
  const block = (e: Event) => e.preventDefault();
  document.addEventListener('gesturestart', block, { passive: false });
  document.addEventListener(
    'touchmove',
    (e: TouchEvent) => { if (e.touches.length > 1) e.preventDefault(); },
    { passive: false },
  );
}

if (inBubbleApp) lockZoom();
